import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})
export class ConfirmDeleteComponent {
  constructor(private dialog:MatDialog){}
  close()
  {
    const okdialog=this.dialog.getDialogById('ok')
    okdialog?.close(true)
  }
}
